module.exports = __webpack_public_path__ + "img/zeng-yuan.2cd9283c.png";